<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useBranding } from 'shared/composables/useBranding';
import SignupForm from './components/Signup/Form.vue';

const store = useStore();
const { replaceInstallationName } = useBranding();
const globalConfig = computed(() => store.getters['globalConfig/get']);
</script>

<!-- 与登录页保持一致的自研品牌化样式; inline-style 待 Tailwind 化 -->
<!-- eslint-disable vue/no-static-inline-styles -->
<template>
  <main
    class="flex flex-col items-center justify-center w-full min-h-screen px-4 py-8"
    style="background-color: #f5f7fa"
  >
    <!-- Logo -->
    <section class="mb-6">
      <img
        :src="globalConfig.logo"
        :alt="globalConfig.installationName"
        class="block w-auto mx-auto"
        style="height: 64px"
      />
    </section>

    <!-- Title -->
    <h2 class="mb-8 text-3xl font-medium text-center" style="color: #1f2937">
      {{ replaceInstallationName($t('REGISTER.TRY_WOOT')) }}
    </h2>

    <!-- Signup Card -->
    <section
      class="w-full max-w-md rounded-2xl"
      style="
        background-color: #ffffff;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
      "
    >
      <div class="p-8">
        <SignupForm />
      </div>
    </section>

    <!-- Login Link -->
    <p class="mt-6 text-sm text-center" style="color: #6b7280">
      {{ $t('REGISTER.HAVE_AN_ACCOUNT') }}{{ ' ' }}
      <router-link to="/app/login" class="font-medium" style="color: #1f93ff">
        {{ $t('LOGIN.SUBMIT') }}
      </router-link>
    </p>
  </main>
</template>
